import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'designSystem/components/Tooltip'
import type { FC, ReactNode } from 'react'

export const HoverTip: FC<{ tip: string; children: ReactNode }> = ({
  tip,
  children,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>{children}</TooltipTrigger>
    <TooltipContent>{tip}</TooltipContent>
  </Tooltip>
)
